export class CompanyDetailsConstants {
  public static CompanyName = {
    MinLength: 1,
    MaxLength: 64,
  };

  public static Address = {
    MaxLength: 128,
  };

  public static PhoneNumber = {
    MaxLength: 32,
  };

  public static Logo = {
    Width: 200,
    Height: 30,
  };

  public static ContactFullName = {
    MaxLength: 128,
  };

  public static CompanyRoles = {
    MaxLength: 128,
    Other: 'other',
  };

  public static CloudUss = {
    ProvisionStatus: {
      NotStarted: 0,
      InProgress: 1,
      Done: 2,
      Failed: 3,
    },
  };
}
